export const getRandomColorPairFromColorWheel = function () {
  const baseColors = [
    "#ff0000", // rouge
    "#0000ff", // bleu
    "#00ff00", // vert
    "#ffff00", // jaune
    "#00ffff", // cyan
    "#ff00ff", // magenta
    "#ff8000", // orange
    "#ff0080", // fuchsia
    "#8000ff", // violet
    "#0080ff", // bleu clair
    "#00ff80", // vert menthe
    "#80ff00", // chartreuse
  ];

  // Choisir une couleur de base aléatoirement
  const base = baseColors[Math.floor(Math.random() * baseColors.length)];

  // Extraire les composantes RGB
  let r = parseInt(base.slice(1, 3), 16);
  let g = parseInt(base.slice(3, 5), 16);
  let b = parseInt(base.slice(5, 7), 16);

  // Ajouter une variation pour créer une teinte légèrement différente
  const variation = () => Math.floor(Math.random() * 41) - 20; // entre -20 et +20

  r = Math.max(0, Math.min(255, r + variation()));
  g = Math.max(0, Math.min(255, g + variation()));
  b = Math.max(0, Math.min(255, b + variation()));

  // Couleur de fond (background)
  const backgroundColor = `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;

  // Couleur complémentaire pour le texte (texte lisible)
  const compR = 255 - r;
  const compG = 255 - g;
  const compB = 255 - b;

  const textColor = `#${compR.toString(16).padStart(2, "0")}${compG
    .toString(16)
    .padStart(2, "0")}${compB.toString(16).padStart(2, "0")}`;

  return {
    background: backgroundColor,
    text: textColor,
  };
};
